import React, { useContext } from "react";
import { useLocation, Outlet } from "react-router-dom";
import AuthContext from "../../contexts/AuthContext";
import { routesWithTitleSync } from "../../config/routeConfig";
import { RightType } from "../../models/Auth";
import PageContainer from "../containers/PageContainer";
import { useTranslation } from "react-i18next";
import BigLoader from "../table/BigLoader";
import LockIcon from '@mui/icons-material/Lock';

export const ProtectedLayout = () => {
  const { userInfo } = useContext(AuthContext);
  const location = useLocation();
  const { t } = useTranslation();

  if (!userInfo) return <BigLoader />;

  const currentRoute = routesWithTitleSync.find(route =>
    location.pathname === route.path ||
    (route.path.includes(":") && location.pathname.startsWith(route.path.split(":")[0]))
  );

  if (!currentRoute || !currentRoute.requiredRights) return <Outlet />;

  const hasAccess = currentRoute.requiredRights.includes(userInfo?.right_type as RightType);
  if (hasAccess) {
    return <Outlet />;
  } else {
    return (
      <PageContainer>
        <div className="w-full h-full flex flex-col items-center justify-center">
            <LockIcon color="error" style={{ fontSize: "64px" }} />
            <h1 className="text-center text-red-500 text-xl font-bold">
                {t("error.no_access_to_page")}
            </h1>
            <p className="text-center">{t("error.no_access_helper")}</p>
        </div>
    </PageContainer>
    );
  }
};
